import React, { Component } from 'react';
import { Menu } from 'semantic-ui-react';
import { Text } from '@cuemath/comps';
import styled from 'styled-components';

import ActivityBlockCreation from 'modals/activity-block-creation';

import Chapter from './chapter/view';
import { ExtraSheet } from './extra-sheet/view';
import '../../../../app.css';

const ActivitySheetsWrapper = styled.div`
  width: 100%;
`;

const MenuContainer = styled(Menu)`
  box-shadow: none !important;
  border: none !important;
`;

const MasteryDataMessage = styled(Text)`
  width: 300px;
  font-size: 18px;
`;

class ActivitySheets extends Component {
  render() {
    const {
      masteryCardData,
      nodeDataList,
      extraSheetList,
      chapterCode,
      programId,
      setBlockDataList,
      setBlockData,
      blockDataList,
      dependencyDataList,
      linkedDataList,
    } = this.props;

    return (
      <ActivitySheetsWrapper>
        <MenuContainer borderless>
          <Menu.Item>
            <ActivityBlockCreation
              fromSheets={true}
              setBlockDataList={setBlockDataList}
              setBlockData={setBlockData}
              chapterCode={chapterCode}
              programId={programId}
            />
          </Menu.Item>
        </MenuContainer>
        {blockDataList.length > 0 ? (
          masteryCardData.length > 0 ? (
            <Chapter
              masteryCardData={masteryCardData}
              dependencyDataList={dependencyDataList}
              nodeDataList={nodeDataList}
              linkedDataList={linkedDataList}
            />
          ) : (
            <MasteryDataMessage>No Mastery data.</MasteryDataMessage>
          )
        ) : (
          <div className="block-data-list-load-message">
            Trying to load blocks, If it's taking more time please check your internet
            connection and then create a new block.
          </div>
        )}
        <ExtraSheet extraSheetList={extraSheetList} />
      </ActivitySheetsWrapper>
    );
  }
}

export default ActivitySheets;
